import { render, staticRenderFns } from "./EditContentPopup.vue?vue&type=template&id=456714a6"
import script from "./EditContentPopup.vue?vue&type=script&lang=js"
export * from "./EditContentPopup.vue?vue&type=script&lang=js"
import style0 from "./EditContentPopup.vue?vue&type=style&index=0&id=456714a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports